import React from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  FixDeafAccessContent,
  GenericHero,
} from '../../components';

import hand from '../../components/SectionHero/image/hand.png';
import css from './FixDeafAccessPage.module.css';

const FixDeafAccessPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <StaticPage
      title="How we fix Deaf Access | Deaf-Led Interpreting & VRS"
      description="How Signalise improves Deaf access through Deaf-led interpreting, VRS, and fair working with interpreters. Join, invest, or work with us."
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description:
          'How Signalise improves Deaf access through Deaf-led interpreting, VRS, and fair working with interpreters.',
        name: 'How We Fix Deaf Access',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            <GenericHero
              className={css.hero}
              title="How We Fix Deaf Access"
              subTitle="Deaf-led, community-owned, and innovation-first. We're redefining interpreting services for the British Deaf community."
            >
              <img fetchpriority="high" src={hand} alt="Signalise hand" className={css.heroHand} />
            </GenericHero>
          </div>
          <FixDeafAccessContent />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

FixDeafAccessPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const FixDeafAccessPage = connect(mapStateToProps)(FixDeafAccessPageComponent);

export default FixDeafAccessPage;
